export default "__VITE_ASSET__BnF4q0N7__"